import { GET_STATS } from './endpoints';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable()
export class StatsService extends BaseService {

    constructor(http: HttpClient) {
        super(http);
    }

    getStats(statsParams: any): Observable<any> {
        const url = GET_STATS + this.makeQueryString(statsParams);
        return this.getRequest(url, null);
    }
}
